// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"2acdb475","727":"5570671d"}[chunkId] + ".chunk.js";
};